
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/ldap-gateway-legacy-apps",
      function () {
        return require("private-next-pages/learn/ldap-gateway-legacy-apps.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/ldap-gateway-legacy-apps"])
      });
    }
  